import React from 'react';
import './PageBackgroundBeam.css';

function PageBackgroundBeam({ children }) {
  return (
    <div className="page-bg">
      <div className="bg-lines">
        <div className="line line-1"></div>
        <div className="line line-2"></div>
        <div className="line line-3"></div>
        <div className="line line-4"></div>
        <div className="line line-5"></div>
        <div className="line line-6"></div>
        <div className="line line-7"></div>
        <div className="beam beam-1"></div>
        <div className="beam beam-2"></div>
        <div className="beam beam-3"></div>
        <div className="beam beam-4"></div>
        <div className="beam beam-5"></div>
        <div className="beam beam-6"></div>
        <div className="beam beam-7"></div>
        <div className="beam-h beam-h1"></div>
        <div className="beam-h beam-h2"></div>
      </div>
      <div className="bg-glow"></div>
      <div className="page-bg-content">
        {children}
      </div>
    </div>
  );
}

export default PageBackgroundBeam;
